import { useState } from "react";
import { visit } from "@hotwired/turbo";
import { useApiRequest } from "../../hooks/useApiRequest";

interface AvatarCreateProps {
  avatar: Avatar;
}

// #STYLE_GUIDE: Create component for new record creation
// - Uses daisyUI components for consistent styling
// - Navigation via Turbo.visit() for SPA-like experience
// - API calls via useApiRequest hook for consistency
// #TODO: This is a basic implementation - customize form fields and validation as needed
export default function AvatarCreate({ avatar }: AvatarCreateProps) {
  const [formData, setFormData] = useState({
    name: "",
  });


  const { loading, makeRequest, getFieldError } = useApiRequest({
    onSuccess: (data) => {
      // #TURBO: Use Turbo.visit for navigation instead of window.location
      visit(`/avatars/${data.id}`);
    },
    onError: (error) => {
      console.error("Failed to create avatar:", error);
    },
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const submitData = {
      ...formData,
    };

    await makeRequest("POST", "/api/v1/avatars", {
      avatar: submitData,
    });
  };

  const handleCancel = () => {
    // #TURBO: Use Turbo.visit for navigation
    visit("/avatars");
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Create New Avatar</h1>
        <button
          onClick={handleCancel}
          className="btn btn-outline"
        >
          Cancel
        </button>
      </div>

      {/* Form */}
      <div className="card bg-base-100 shadow-xl">
        <div className="card-body">
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Name field */}
            <div className="form-control">
              <label className="label">
                <span className="label-text">Name</span>
              </label>
              <input
                type="text"
                className={`input input-bordered ${getFieldError('name') ? 'input-error' : ''}`}
                placeholder="Enter name"
                value={formData.name}
                onChange={(e) => setFormData(prev => ({
                  ...prev,
                  name: e.target.value
                }))}
              />
              {getFieldError('name') && (
                <label className="label">
                  <span className="label-text-alt text-error">{getFieldError('name')}</span>
                </label>
              )}
            </div>

            {/* Submit buttons */}
            <div className="form-control mt-6">
              <div className="flex gap-2">
                <button
                  type="submit"
                  className="btn btn-primary flex-1"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="loading loading-spinner loading-sm"></span>
                      Creating...
                    </>
                  ) : (
                    "Create Avatar"
                  )}
                </button>
                <button
                  type="button"
                  onClick={handleCancel}
                  className="btn btn-outline"
                  disabled={loading}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
